module.exports = __webpack_public_path__ + "files/dda5dbd3124ae835adb5b6bf3cbd5f0d.png";